// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b6d41f72","239":"d3df1972","272":"f8c2939b","453":"3538a65f","732":"2c3f282f","762":"039b1047","970":"7f82d393"}[chunkId] + ".chunk.js";
};